import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import classes from "./inventorySparesLotListPage.module.css";

import { InventorySparesLotListFilterPage } from "./inventorySparesLotListFilterPage/InventorySparesLotListFilterPage";
import { InventorySparesLotListTablePage } from "./inventorySparesLotListTable/InventorySparesLotListTablePage";

import {
  useGetInventorySpareLotListQuery,
  makeInventorySpareLotSelectors,
  makeSelectInventorySpareLotPagination,
} from "../../../services/inventory/spares/inventorySpareLotListApiSlice";

import {
  selectInventorySpareLotFilterState,
  setInventorySpareLotListCursor,
} from "../../../store/inventory/inventorySpareLotListSlice";

export const InventorySparesLotListPage = () => {
  const navigate = useNavigate();
  const { inventoryId } = useParams();
  const dispatch = useDispatch();

  /* =====================
     SELECTORS (FACTORY)
  ===================== */

  /* =====================
     INFINITE SCROLL
  ===================== */

  return (
    <div className={classes.box}>
      <InventorySparesLotListFilterPage />

      <InventorySparesLotListTablePage />
    </div>
  );
};
